export interface IMedicationAsync {
    id: number;
    name: string;
    icon: string;
    typeName: string;
    genericName: string;
    companyName: string;
    supplierName: string;
}